import * as Yup from 'yup';
import {
    conditionallyRequired,
    displayIf,
    requiredIf,
    requiredCheck,
    requiredMessage,
    requiredTrue,
} from '../../../utils/extensions/yup-extensions';
import { RatingsMap } from '@core/constants/chips/ratings.constants';

export const ReviewEvidenceFormSchema = Yup.object().shape({
    uploadEvidence: Yup.mixed().label('Uploaded Evidence').notRequired().nullable(),

    rating: Yup.array().label('Rating').required(requiredMessage).nullable().max(1),

    haveReviewed: Yup.boolean()
        .label('I have reviewed the evidence.')
        .required()
        .nullable()
        .test(requiredTrue()),

    rationale: Yup.string()
        .label('Rationale')
        .max(3000)
        .nullable()
        .meta({
            displayIf: displayIf('rating', [RatingsMap.yellow, RatingsMap.amber, RatingsMap.red]),
        }),

    canAccept: Yup.boolean().label('Are you happy with the evidence?').required(requiredMessage),

    comment: Yup.string()
        .label('Reason for declining evidence')
        .nullable()
        .max(3000)
        .when('canAccept', requiredIf([false, 'false']))
        .test(conditionallyRequired('canAccept', [false, 'false']))
        .meta({
            displayIf: displayIf('canAccept', [false, 'false']),
            requiredIf: requiredCheck('canAccept', [false, 'false']),
        }),
});
